// Widget Scripts

// Custom Theme Scripts
import './js/localjs.js';
import 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/js/all.min.js'



// Initialize Homepage Widgets if is required
if (window.location.pathname === '/') {
    $(document).ready(function () {
    });

};
